module.exports = __webpack_public_path__ + "static/image/logo-family/logo_takeout@2x.png?f793563c";